const fields = [
  {
    key: 'title',
    type: 'input',
    templateOptions: {
      label: 'title'
    }
  },
  {
    key: 'shortDescription',
    type: 'textarea',
    templateOptions: {
      label: 'shortDescription'
    }
  },
  {
    key: 'publishDate',
    type: 'datepicker',
    templateOptions: {
      label: 'publishDate'
    }
  },
  {
    key: 'highlightEnabled',
    type: 'boolean',
    templateOptions: {
      label: 'highlightEnabled',
      description: 'highlightEnabledDescription'
    }
  },
  {
    key: 'highlightUntil',
    type: 'datepicker',
    templateOptions: {
      label: 'highlightUntil'
    },
    display: (field, model) => model.highlightEnabled
  },
  {
    key: 'announcementEnabled',
    type: 'boolean',
    templateOptions: {
      label: 'announcementEnabled',
      description: 'announcementEnabledDescription'
    }
  },
  {
    key: 'announcementUntil',
    type: 'datepicker',
    templateOptions: {
      label: 'announcementUntil'
    },
    display: (field, model) => model.announcementEnabled
  },
  {
    key: 'announcementType',
    type: 'ntm-select',
    isString: true,
    options: ['always', 'once'],
    templateOptions: {
      label: 'announcementType',
      translated: true,
      translationObject: 'announcementTypes'
    },
    display: (field, model) => model.announcementEnabled
  },
  {
    key: 'tags',
    type: 'ntm-select',
    isString: true,
    taggable: true,
    multiple: true,
    optionsApi: 'tags',
    templateOptions: {
      label: 'tags'
    }
  },
  {
    key: 'content',
    type: 'html',
    templateOptions: {
      label: 'content',
      uuid: null,
      assetType: null
    }
  }
]

export default fields
